import React from "react";
import { Typography } from "@mui/material";

type SuccessModalTitle = React.ComponentProps<"div">;

export const SuccessModalTitle = ({ children }: SuccessModalTitle) => {
  return (
    <Typography className={"font-semibold text-3xl text-center mt-8"}>
      {children}
    </Typography>
  );
};
